class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.mainDetailsSummary = this.mainDetailsToggle.querySelector('summary');
    this.content = this.mainDetailsSummary.nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  get isOpen() {
    return this.mainDetailsToggle.hasAttribute('open');
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.isOpen) {
      this.animations.forEach(animation => animation.play());
    } else {
      this.animations.forEach(animation => animation.cancel());
    }
  }

  open() {
    if (this.isOpen) return;
    this.mainDetailsToggle.setAttribute('open', true);
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
    this.onToggle();
  }

  close() {
    if (!this.isOpen) return;
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
    this.onToggle();
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenuItem extends DetailsDisclosure {
  #abortController = new AbortController();

  constructor() {
    super();
    this.header = document.querySelector('sticky-header');

    this.mainDetailsSummary.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.header.addEventListener('mouseleave', this.debouncedOnMouseLeave.bind(this), { signal: this.#abortController.signal });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#abortController.abort();
  }

  open() {
    this.header.closeMenuDisclosure();
    super.open()
  }

  onMouseEnter() {
    this.open();
  }

  onMouseLeave() {
    this.close();
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty('--header-bottom-position-desktop', `${Math.floor(this.header.getBoundingClientRect().bottom)}px`);
  }

  debouncedOnMouseLeave = debounce(this.onMouseLeave.bind(this), 350);
}

customElements.define('header-menu-item', HeaderMenuItem);
